"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPersonalizeData = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const helpers_1 = require("../helpers");
const getPersonalizeData = (input) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    try {
        if (!input) {
            throw new helpers_1.ContentError('Invalid parameters - input required');
        }
        if (!input.oj) {
            throw new helpers_1.OjError('Invalid parameters - OJ response required');
        }
        if (!input.content) {
            throw new helpers_1.ContentError('Invalid parameters - content required');
        }
        const { accommodations, offers, property, termsAndConditions: terms, onlineTransfers, } = input.content;
        if (!accommodations) {
            throw new helpers_1.ContentError('Invalid parameters - content.accommodations required');
        }
        if (!offers) {
            throw new helpers_1.ContentError('Invalid parameters - content.offers required');
        }
        if (!property) {
            throw new helpers_1.ContentError('Invalid parameters - content.property required');
        }
        if (!terms || !Array.isArray(terms)) {
            throw new helpers_1.ContentError('Invalid parameters - content.terms array required');
        }
        const error = helpers_1.getError({
            language: input.language,
            employee: !!input.employee,
            propertyMetaData: property,
            supplierErrors: (_a = input.oj) === null || _a === void 0 ? void 0 : _a.supplierErrors,
            apiErrors: (_b = input.oj) === null || _b === void 0 ? void 0 : _b.apiErrors,
        });
        const ojResults = input.oj.results;
        if (!ojResults) {
            throw new helpers_1.OjError('Unexpected OJ Response - No Results');
        }
        if (!((_c = ojResults.hotelProducts) === null || _c === void 0 ? void 0 : _c.length)) {
            throw new helpers_1.OjError('Unexpected OJ Response - No hotelProducts');
        }
        if (!ojResults.hotelProducts[0].duration) {
            throw new helpers_1.OjError('Unexpected OJ Response - No duration');
        }
        const propertyName = helpers_1.formatBeverlyWilshire(property.shortName);
        let promoOffer;
        if (input.promoCode) {
            promoOffer = {
                title: '',
                urlWeb: '',
                urlApi: '',
                id: '',
                inclusionsArray: [],
                inclusions: [],
                hidden: false,
                conditions: [],
            };
        }
        const bedsByOws = accommodations.bookableAccommodations.reduce((bookableRooms, room) => {
            const bedTypes = room.sleepingArrangements.reduce((bookableBeds, bed) => {
                if (!bed.owsCode) {
                    return bookableBeds;
                }
                const bedWithName = Object.assign(Object.assign({}, bed), { uniqueName: room.uniqueName });
                return Object.assign(Object.assign({}, bookableBeds), { [bed.owsCode]: bedWithName });
            }, {});
            return Object.assign(Object.assign({}, bookableRooms), bedTypes);
        }, {});
        let propertyLink = '';
        let propertiesPath = '/';
        if (input.pp) {
            propertiesPath = '/properties/';
        }
        if (input.language === 'en') {
            propertyLink = propertiesPath + property.urlName;
        }
        else {
            propertyLink = `/${input.language}${propertiesPath}${property.urlName}`;
        }
        const propertyData = {
            owsCode: property.owsCode || '',
            orsCode: property.orsCode || '',
            name: {
                url: propertyLink,
                text: helpers_1.formatBeverlyWilshire(property.shortName),
            },
            street: property.street,
            city: property.city,
            state: property.state,
            postalCode: property.zipcode,
            country: property.country || '',
            phone: property.propertyPhone ? { number: property.propertyPhone } : undefined,
            latitude: property.latitude || '',
            longitude: property.longitude || '',
        };
        const cancelBy = helpers_1.getCancelByDate(terms, property.timeZone);
        const cancelAllowed = !!cancelBy && !input.isPrepaid;
        const onlineTransferPhone = (onlineTransfers === null || onlineTransfers === void 0 ? void 0 : onlineTransfers.contactTelephone) ||
            property.reservationPhone ||
            property.propertyPhone;
        const dictionaryKeys = {
            thankYouMessage: helpers_1.setDictionaryKey('Thank You, {0} {1}. We Look Forward To Welcoming You.'),
            emailSentMessage: helpers_1.setDictionaryKey('bk41.aconfiramtionemail'),
            personalizeYourStay: input.pp
                ? helpers_1.setDictionaryKey("Personalize Your Client's Stay")
                : helpers_1.setDictionaryKey('Personalize Your Stay'),
            yourArrival: input.pp
                ? helpers_1.setDictionaryKey('Arrival Details')
                : helpers_1.setDictionaryKey('Your Arrival'),
            yourBooking: input.pp
                ? helpers_1.setDictionaryKey('Reservation')
                : helpers_1.setDictionaryKey('Your Booking'),
            yourReservation: input.pp
                ? helpers_1.setDictionaryKey('Reservation')
                : helpers_1.setDictionaryKey('Your Reservation'),
            onlineTransfersTitle: input.pp
                ? helpers_1.setDictionaryKey('May we assist with transportation?')
                : helpers_1.setDictionaryKey('bk42.transport.may.we.assist'),
        };
        let sameDayBooking = false;
        if (ojResults.startDate) {
            sameDayBooking = property.timeZone
                ? moment_timezone_1.default
                    .tz(ojResults.startDate, property.timeZone)
                    .subtract(24, 'hours')
                    .isBefore(moment_timezone_1.default.tz(property.timeZone))
                : moment_timezone_1.default(ojResults.startDate)
                    .subtract(24, 'hours')
                    .isBefore(moment_timezone_1.default());
        }
        if (!cancelAllowed) {
            if (sameDayBooking) {
                dictionaryKeys.sameDayHeading = helpers_1.setDictionaryKey('PLEASE CONTACT THE HOTEL TO CONFIRM SAME DAY BOOKINGS.');
                if (property.supportPhone) {
                    dictionaryKeys.sameDayMessage = helpers_1.setDictionaryKey('If you are arriving on the same day that you book your reservation online, we recommend that you confirm with the Hotel directly at {0}, as online processing can sometimes take several hours.', [property.supportPhone]);
                }
                else {
                    dictionaryKeys.sameDayMessage = helpers_1.setDictionaryKey('If you are arriving on the same day that you book your reservation online, we recommend that you confirm with the Hotel directly, as online processing can sometimes take several hours.');
                }
            }
            dictionaryKeys.cancelationMessage = helpers_1.setDictionaryKey('Reservation cannot be canceled online. Please contact the Hotel or Worldwide Reservations for assistance.');
        }
        let thankYouParam1 = '';
        let thankYouParam2 = '';
        const guest = (_d = ojResults.customers) === null || _d === void 0 ? void 0 : _d.find(customer => !customer.contactType);
        const agent = (_e = ojResults.customers) === null || _e === void 0 ? void 0 : _e.find(customer => customer.contactType === 'TRAVEL_AGENT');
        const booker = (_f = ojResults.customers) === null || _f === void 0 ? void 0 : _f.find(customer => customer.contactType === 'BOOK_FOR');
        const contactEmail = ((_g = ojResults.contactDetails) === null || _g === void 0 ? void 0 : _g.email) || '';
        if (agent || booker) {
            const guestFirst = guest ? guest.name.firstName || '' : '';
            const guestLast = guest ? guest.name.surname || '' : '';
            const thankYouParam3 = `${guestFirst} ${guestLast}`.trim();
            if (agent) {
                thankYouParam2 = agent ? agent.name.firstName || '' : '';
            }
            else if (booker) {
                thankYouParam1 = booker.name.title || booker.name.firstName || '';
                thankYouParam2 = booker.name.surname || '';
            }
            dictionaryKeys.thankYouMessage.key =
                'Thank You, {0} {1}. We Look Forward To Welcoming {2}.';
            dictionaryKeys.thankYouMessage.params = [
                thankYouParam1,
                thankYouParam2,
                thankYouParam3,
            ];
            let emailParam1 = '';
            if (input.pp && agent) {
                emailParam1 = ((_h = agent.emails) === null || _h === void 0 ? void 0 : _h.length) ? agent.emails[0].email || '' : '';
                dictionaryKeys.emailSentMessage.key =
                    'Confirmation has been sent to {0}.  If you would like to send a confirmation to the guest, please use the ';
                dictionaryKeys.emailSentMessage.params = [emailParam1];
                dictionaryKeys.emailSentLinkText = helpers_1.setDictionaryKey('confirmation tool');
                dictionaryKeys.emailSentMessageEnd = helpers_1.setDictionaryKey('.');
            }
            else {
                if (agent) {
                    emailParam1 = ((_j = agent.emails) === null || _j === void 0 ? void 0 : _j.length) ? agent.emails[0].email || '' : '';
                }
                else {
                    emailParam1 = ((_k = booker === null || booker === void 0 ? void 0 : booker.emails) === null || _k === void 0 ? void 0 : _k.length) ? booker.emails[0].email || '' : '';
                }
                if (input.sendGuestEmail && contactEmail) {
                    dictionaryKeys.emailSentMessage.key =
                        'Confirmation emails have been sent to {0}, {1}.';
                    dictionaryKeys.emailSentMessage.params = [emailParam1, contactEmail];
                }
                else {
                    dictionaryKeys.emailSentMessage.params = [emailParam1];
                }
            }
        }
        else {
            if (guest) {
                thankYouParam1 = guest.name.title || guest.name.firstName || '';
                thankYouParam2 = guest.name.surname || '';
            }
            dictionaryKeys.thankYouMessage.params = [thankYouParam1, thankYouParam2];
            dictionaryKeys.emailSentMessage.params = [contactEmail];
        }
        const rooms = [];
        const employeeCompBooking = helpers_1.isEmployeeComplimentaryRate(input.promoCode);
        const numberOfRooms = ojResults.hotelProducts.length;
        const numberOfNights = ojResults.hotelProducts[0].duration;
        let totalAdults = 0;
        let totalChildren = 0;
        (_l = ojResults.hotelProducts) === null || _l === void 0 ? void 0 : _l.forEach((ojRoom, roomIndex) => {
            var _a, _b, _c, _d, _e;
            const adults = ((_a = ojRoom.guestCount) === null || _a === void 0 ? void 0 : _a.numberAdults) || 0;
            const children = ((_b = ojRoom.guestCount) === null || _b === void 0 ? void 0 : _b.numberChildren) || 0;
            totalAdults += adults;
            totalChildren += children;
            const roomCode = ((_c = ojRoom.roomTypes) === null || _c === void 0 ? void 0 : _c.length) ? ojRoom.roomTypes[0].roomTypeId : '';
            const foundRoom = bedsByOws[roomCode];
            if (!foundRoom) {
                throw new helpers_1.OjError('Unexpected OJ Response - Room Not Found');
            }
            const offerCode = (_d = ojRoom.roomRate) === null || _d === void 0 ? void 0 : _d.ratePlanCode;
            let foundOffer;
            let ppOffer = false;
            if (input.promoCode) {
                if (input.promoCode === offerCode) {
                    const employeeRateTitle = helpers_1.getEmployeeRateTitle(input.promoCode);
                    foundOffer = Object.assign(Object.assign({}, promoOffer), { title: employeeRateTitle ||
                            helpers_1.fixPromoTitle((_e = ojRoom.roomRate) === null || _e === void 0 ? void 0 : _e.ratePlanTitle) ||
                            '' });
                }
            }
            else if (input.pp) {
                foundOffer = offers.bookableOffers.find(offer => offer.ppCode === offerCode);
                if (foundOffer) {
                    ppOffer = true;
                }
                else {
                    foundOffer = offers.bookableOffers.find(offer => offer.owsCode === offerCode);
                }
            }
            else {
                foundOffer = offers.bookableOffers.find(offer => offer.owsCode === offerCode);
            }
            if (!foundOffer) {
                throw new helpers_1.OjError('Unexpected OJ Response - Offer Not Found');
            }
            rooms.push({
                owsCode: foundRoom.owsCode || '',
                orsCode: foundRoom.orsCode || '',
                name: foundRoom.title || '',
                image: foundRoom.images.length ? { path: foundRoom.images[0] } : undefined,
                description: helpers_1.formatBeverlyWilshire(foundRoom.unitLongDescription),
                offer: {
                    owsCode: foundOffer.owsCode,
                    orsCode: foundOffer.orsCode,
                    title: ppOffer
                        ? `Preferred Partner - ${foundOffer.title}`
                        : foundOffer.title || '',
                },
                bedType: foundRoom.bedTypeDescription || '',
                numberOfNights,
                adults,
                children,
            });
        });
        const personalizeData = {
            property: propertyData,
            showAppDownload: !input.pp && !input.employee && input.language === 'en',
            cancelation: {
                allowed: cancelAllowed,
                by: cancelAllowed ? cancelBy : undefined,
            },
            rooms,
            onlineTransfers: {
                enabled: true,
                phone: onlineTransferPhone ? { number: onlineTransferPhone } : undefined,
            },
            welcomeAmenities: {
                hidden: input.pp,
                enabled: true,
                phone: property.propertyPhone ? { number: property.propertyPhone } : undefined,
            },
            webChat: {
                enabled: false,
            },
            dictionaryKeys,
            numberOfRooms,
            numberOfNights,
            totalAdults,
            totalChildren,
        };
        if (!input.pp && !input.employee && property.globalTollFreeLink) {
            personalizeData.tollFreeNumbers = {
                url: property.globalTollFreeLink,
                textDictKey: helpers_1.setDictionaryKey('Toll Free Numbers By Country'),
            };
        }
        const webUrlEn = property.urlWeb
            ? property.urlWeb.replace(/\/([a-z_]{2}(_[a-z]{2,4})?)\//, '/en/')
            : '';
        if (input.pp) {
            personalizeData.contactUs = {
                url: '/contact/property_key_contacts/',
                textDictKey: helpers_1.setDictionaryKey('Contact Us'),
            };
        }
        personalizeData.webChat = { enabled: false };
        if (property.webChatConfig) {
            const webChat = ((_m = property.webChatConfig['chatinrbf-bookingflow__step-4']) === null || _m === void 0 ? void 0 : _m.enabled) ? property.webChatConfig['chatinrbf-bookingflow__step-4']
                : property.webChatConfig['chatinrbf-bookingflow'];
            if (webChat && webChat.enabled) {
                personalizeData.webChat = {
                    enabled: webChat.enabled && !input.employee && !input.pp,
                    id: webChat.id,
                    integrationId: webChat.integrationId,
                    propertyName: property.landingPagePropertyName,
                    propertyCode: property.owsCode,
                };
                if ((_p = (_o = property.upcomingTrip) === null || _o === void 0 ? void 0 : _o.desktopImage) === null || _p === void 0 ? void 0 : _p.croppedPath) {
                    personalizeData.webChat.propertyImage = {
                        path: (_r = (_q = property.upcomingTrip) === null || _q === void 0 ? void 0 : _q.desktopImage) === null || _r === void 0 ? void 0 : _r.croppedPath,
                    };
                }
            }
        }
        if (error.messageDictKey.key) {
            personalizeData.bookingError = {
                labelDictKey: error.labelDictKey,
                messageDictKey: error.messageDictKey,
                descriptionDictKey: error.descriptionDictKey,
                contactReservations: error.contactReservations,
                field: error.field,
            };
        }
        return personalizeData;
    }
    catch (err) {
        if (err instanceof helpers_1.ContentError || err instanceof helpers_1.OjError) {
            return { error: err };
        }
        throw err;
    }
};
exports.getPersonalizeData = getPersonalizeData;
